export default {
	"Card.Online": "上线",
	"Card.Hot": "火爆",
	"Card.SoldOutSoon": "即将售罄",
	"Card.SnappingUp": "抢购中",
	"Card.OffTheEnd": "离结束",
	"Card.ComingSoon": "即将开始",
	"Card.sky": "天",
	"Card.Sold": "已售",
	"Card.SnapItUpNow": "立即抢购",
	"Card.MarketingMallComponentClick": "营销商城_组件点击",
	"Card.MarketingMarketplace": "营销商城",
	"Card.AListOfStoreItems": "店铺商品列表",
	"Card.StoreResourceBits": "店铺资源位",
	"Card.More": "更多>"
}